var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { attrs: { "app-name": "radio" } },
    [
      _c("Navigation", { attrs: { "station-data": _vm.stations } }),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c(
            "div",
            { staticClass: "controls" },
            [
              _c(
                "Breadcrumbs",
                [
                  _c("Breadcrumb", { attrs: { title: "Home", href: "#/" } }),
                  _vm._v(" "),
                  _c("Breadcrumb", {
                    attrs: { title: "Favorites", href: "#/favorites" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Actions",
                [
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-add", "close-after-click": true },
                      on: {
                        click: function($event) {
                          return _vm.showModal()
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t\tAdd station\n\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionButton",
                    {
                      attrs: {
                        icon: "icon-download",
                        "close-after-click": true
                      },
                      on: { click: _vm.doExport }
                    },
                    [_vm._v("\n\t\t\t\t\tExport favorites\n\t\t\t\t")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("Table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.pageLoading && _vm.stations.length > 0,
                expression: "!pageLoading && stations.length > 0"
              }
            ],
            attrs: { "station-data": _vm.stations, favorites: _vm.favorites },
            on: {
              doPlay: _vm.doPlay,
              doFavor: _vm.doFavor,
              toggleSidebar: _vm.toggleSidebar
            }
          }),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("EmptyContent", { attrs: { icon: "icon-loading" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.stations.length === 0 && !_vm.pageLoading
            ? _c(
                "EmptyContent",
                {
                  attrs: { icon: _vm.emptyContentIcon },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "desc",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.emptyContentDesc) +
                                "\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    923469476
                  )
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.emptyContentMessage) + "\n\t\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modal
            ? _c("Modal", { on: { close: _vm.closeModal } }, [
                _c("div", { staticClass: "modalContent" }, [
                  _c("h2", { staticClass: "oc-dialog-title" }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.t("radio", "Add custom station")) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("form", { on: { submit: _vm.addCustomStation } }, [
                    _c("label", { attrs: { for: "stationName" } }, [
                      _vm._v(_vm._s(_vm.t("radio", "Name")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.station.name,
                          expression: "station.name"
                        }
                      ],
                      attrs: { id: "stationName", type: "text", required: "" },
                      domProps: { value: _vm.station.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.station, "name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "streamUrl" } }, [
                      _vm._v(_vm._s(_vm.t("radio", "Stream url")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.station.streamUrl,
                          expression: "station.streamUrl"
                        }
                      ],
                      attrs: { id: "streamUrl", type: "url", required: "" },
                      domProps: { value: _vm.station.streamUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.station,
                            "streamUrl",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "faviconUrl" } }, [
                      _vm._v(_vm._s(_vm.t("radio", "Favicon url")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.station.faviconUrl,
                          expression: "station.faviconUrl"
                        }
                      ],
                      attrs: { id: "faviconUrl", type: "url" },
                      domProps: { value: _vm.station.faviconUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.station,
                            "faviconUrl",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "formControls" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "icon-add-white primary button new-button",
                          attrs: { type: "submit" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.t("radio", "Add station")) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Sidebar", {
        attrs: {
          "show-sidebar": _vm.showSidebar,
          "sidebar-station": _vm.sidebarStation
        },
        on: { toggleSidebar: _vm.toggleSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }